export default __webpack_public_path__ + "static/media/ic_multiswap.ab55c437.svg";